"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * PlumbingWorld-3.0
 * PlumbingWorld API
 *
 * Contact: jspencer@juliusspencer.co.nz
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeneralLogTypeToJSON = exports.GeneralLogTypeFromJSONTyped = exports.GeneralLogTypeFromJSON = exports.GeneralLogType = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var GeneralLogType;
(function (GeneralLogType) {
    GeneralLogType["REGISTRATION"] = "REGISTRATION";
    GeneralLogType["USER_VERIFIED"] = "USER_VERIFIED";
    GeneralLogType["TRADING_ACCOUNT_UPDATED"] = "TRADING_ACCOUNT_UPDATED";
    GeneralLogType["ORDER_CREATED"] = "ORDER_CREATED";
    GeneralLogType["ORDER_SENT_TO_BRANCH"] = "ORDER_SENT_TO_BRANCH";
    GeneralLogType["ORDER_SENT_TO_BRANCH_FAILURE"] = "ORDER_SENT_TO_BRANCH_FAILURE";
    GeneralLogType["NEW_ACCOUNT_EMAIL_SENT"] = "NEW_ACCOUNT_EMAIL_SENT";
    GeneralLogType["NEW_ACCOUNT_EMAIL_FAILURE"] = "NEW_ACCOUNT_EMAIL_FAILURE";
    GeneralLogType["NEW_USER_EMAIL_SENT"] = "NEW_USER_EMAIL_SENT";
    GeneralLogType["NEW_USER_EMAIL_FAILURE"] = "NEW_USER_EMAIL_FAILURE";
    GeneralLogType["RESET_PASSWORD_EMAIL_SENT"] = "RESET_PASSWORD_EMAIL_SENT";
    GeneralLogType["RESET_PASSWORD_EMAIL_FAILURE"] = "RESET_PASSWORD_EMAIL_FAILURE";
    GeneralLogType["CREATED_DEFAULT_CLOSURE"] = "CREATED_DEFAULT_CLOSURE";
    GeneralLogType["CREATED_BRANCH_CLOSURE"] = "CREATED_BRANCH_CLOSURE";
    GeneralLogType["UPDATED_DEFAULT_CLOSURE"] = "UPDATED_DEFAULT_CLOSURE";
    GeneralLogType["UPDATED_BRANCH_CLOSURE"] = "UPDATED_BRANCH_CLOSURE";
    GeneralLogType["DELETED_DEFAULT_CLOSURE"] = "DELETED_DEFAULT_CLOSURE";
    GeneralLogType["DELETED_BRANCH_CLOSURE"] = "DELETED_BRANCH_CLOSURE";
    GeneralLogType["VIEW_INVOICES"] = "VIEW_INVOICES";
    GeneralLogType["VIEW_INVOICE"] = "VIEW_INVOICE";
    GeneralLogType["VIEW_STATEMENTS"] = "VIEW_STATEMENTS";
    GeneralLogType["VIEW_STATEMENT"] = "VIEW_STATEMENT";
    GeneralLogType["CONTACT_EMAIL"] = "CONTACT_EMAIL";
    GeneralLogType["INTEGRATION_EMAIL"] = "INTEGRATION_EMAIL";
    GeneralLogType["ACCOUNT_UPDATED_EMAIL"] = "ACCOUNT_UPDATED_EMAIL";
    GeneralLogType["ORDER_UPDATE_SMS_SENT"] = "ORDER_UPDATE_SMS_SENT";
    GeneralLogType["ORDER_UPDATE_SMS_FAILURE"] = "ORDER_UPDATE_SMS_FAILURE";
    GeneralLogType["ORDER_UPDATE_EMAIL_SENT"] = "ORDER_UPDATE_EMAIL_SENT";
    GeneralLogType["ORDER_UPDATE_EMAIL_FAILURE"] = "ORDER_UPDATE_EMAIL_FAILURE";
    GeneralLogType["USER_UPDATE"] = "USER_UPDATE";
    GeneralLogType["PRICEBOOK_REQUEST"] = "PRICEBOOK_REQUEST";
    GeneralLogType["PRICEBOOK_SUBSCRIPTION_UPDATE"] = "PRICEBOOK_SUBSCRIPTION_UPDATE";
    GeneralLogType["INTEGRATION_CONNECT"] = "INTEGRATION_CONNECT";
    GeneralLogType["INTEGRATION_DISCONNECT"] = "INTEGRATION_DISCONNECT";
    GeneralLogType["INTEGRATION_CONNECT_STATUS_UPDATE"] = "INTEGRATION_CONNECT_STATUS_UPDATE";
    GeneralLogType["INTEGRATION_DISCONNECT_STATUS_UPDATE"] = "INTEGRATION_DISCONNECT_STATUS_UPDATE";
    GeneralLogType["FEATURE_FLAG_UPDATE"] = "FEATURE_FLAG_UPDATE";
    GeneralLogType["QUOTE_CREATE"] = "QUOTE_CREATE";
    GeneralLogType["QUOTE_UPDATE"] = "QUOTE_UPDATE";
    GeneralLogType["QUOTE_DELETE"] = "QUOTE_DELETE";
    GeneralLogType["QUOTE_SUBMIT"] = "QUOTE_SUBMIT";
    GeneralLogType["QUOTE_SEND"] = "QUOTE_SEND";
    GeneralLogType["LABEL_ORDER_CREATED"] = "LABEL_ORDER_CREATED";
    GeneralLogType["LABEL_ORDER_UPDATED"] = "LABEL_ORDER_UPDATED";
    GeneralLogType["ORDER_UPDATED"] = "ORDER_UPDATED";
    GeneralLogType["ORDER_NOTIFY_ME_EMAIL_SENT"] = "ORDER_NOTIFY_ME_EMAIL_SENT";
    GeneralLogType["ORDER_NOTIFY_ME_EMAIL_FAILURE"] = "ORDER_NOTIFY_ME_EMAIL_FAILURE";
    GeneralLogType["LIST_DELETE"] = "LIST_DELETE";
    GeneralLogType["LIST_CREATE"] = "LIST_CREATE";
    GeneralLogType["LIST_UPDATE_START"] = "LIST_UPDATE_START";
    GeneralLogType["LIST_UPDATE_END"] = "LIST_UPDATE_END";
    GeneralLogType["ORDER_RELEASED"] = "ORDER_RELEASED";
    GeneralLogType["CAROUSEL_CHANGE"] = "CAROUSEL_CHANGE";
    GeneralLogType["RESET_PASSWORD_MOBILE_SENT"] = "RESET_PASSWORD_MOBILE_SENT";
    GeneralLogType["RESET_PASSWORD_MOBILE_FAILURE"] = "RESET_PASSWORD_MOBILE_FAILURE";
    GeneralLogType["HOME_PAGE_ITEMS_CHANGE"] = "HOME_PAGE_ITEMS_CHANGE";
    GeneralLogType["FRAMEWORKS_REQUEST"] = "FRAMEWORKS_REQUEST";
    GeneralLogType["INVOICE_COMMENT_UPDATED"] = "INVOICE_COMMENT_UPDATED";
    GeneralLogType["ORDER_SENT_TO_SALES_COORDINATOR"] = "ORDER_SENT_TO_SALES_COORDINATOR";
    GeneralLogType["ORDER_SENT_TO_SALES_COORDINATOR_FAILURE"] = "ORDER_SENT_TO_SALES_COORDINATOR_FAILURE";
    GeneralLogType["CUSTOMER_CONTRACTS_ASSIGNED_NEW_USER"] = "CUSTOMER_CONTRACTS_ASSIGNED_NEW_USER";
    GeneralLogType["CUSTOMER_CONTRACTS_DELETED_USER"] = "CUSTOMER_CONTRACTS_DELETED_USER";
    GeneralLogType["CUSTOMER_CONTRACTS_CHANGED_BRANCH_ACCESS"] = "CUSTOMER_CONTRACTS_CHANGED_BRANCH_ACCESS,";
    GeneralLogType["CUSTOMER_CONTRACTS_APPROVED_SUBMISSION"] = "CUSTOMER_CONTRACTS_APPROVED_SUBMISSION,";
    GeneralLogType["CUSTOMER_CONTRACTS_REJECTED_REQUEST"] = "CUSTOMER_CONTRACTS_REJECTED_REQUEST,";
    GeneralLogType["CUSTOMER_CONTRACTS_CHANGED_TIERS"] = "CUSTOMER_CONTRACTS_CHANGED_TIERS,";
    GeneralLogType["CUSTOMER_CONTRACTS_SUBMITTED_NATIONAL_CONTRACT"] = "CUSTOMER_CONTRACTS_SUBMITTED_NATIONAL_CONTRACT,";
    GeneralLogType["CUSTOMER_CONTRACTS_SUBMITTED_STANDARD_CONTRACT"] = "CUSTOMER_CONTRACTS_SUBMITTED_STANDARD_CONTRACT,";
    GeneralLogType["WINDCAVE_PAYMENT_CREATED"] = "WINDCAVE_PAYMENT_CREATED";
    GeneralLogType["WINDCAVE_PAYMENT_COMPLETED"] = "WINDCAVE_PAYMENT_COMPLETED";
    GeneralLogType["WINDCAVE_PAYMENT_FAILED"] = "WINDCAVE_PAYMENT_FAILED";
    GeneralLogType["WINDCAVE_PAYMENT_CANCELLED"] = "WINDCAVE_PAYMENT_CANCELLED";
    GeneralLogType["DYNAMICS_ACCOUNT_PAYMENT_CREATED"] = "DYNAMICS_ACCOUNT_PAYMENT_CREATED";
    GeneralLogType["DYNAMICS_ACCOUNT_PAYMENT_FAILED"] = "DYNAMICS_ACCOUNT_PAYMENT_FAILED";
    GeneralLogType["FINANCE_EMAIL_SENT"] = "FINANCE_EMAIL_SENT";
    GeneralLogType["FINANCE_EMAIL_SEND_FAILURE"] = "FINANCE_EMAIL_SEND_FAILURE";
    GeneralLogType["PAYMENT_COMPLETED"] = "PAYMENT_COMPLETED";
})(GeneralLogType = exports.GeneralLogType || (exports.GeneralLogType = {}));
function GeneralLogTypeFromJSON(json) {
    return GeneralLogTypeFromJSONTyped(json, false);
}
exports.GeneralLogTypeFromJSON = GeneralLogTypeFromJSON;
function GeneralLogTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.GeneralLogTypeFromJSONTyped = GeneralLogTypeFromJSONTyped;
function GeneralLogTypeToJSON(value) {
    return value;
}
exports.GeneralLogTypeToJSON = GeneralLogTypeToJSON;
